/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import cx from 'classnames'
import { Tooltip, Button } from '@finanso/react-uikit'
import { useStore } from 'effector-react'

import styles from './Table.module.scss'

import CheckCircle from '../../../../../assets/images/CheckCircle'
import { Period, Subscribe } from '../../../../services/api/Tafiff'
import { $handlerTariff } from '../../../../state/Tariff/store'
import { StatusCard } from '../../../enum/StatusCard'
import { TableSkeleton } from './Table.skeleton'
import { Translate } from 'react-localize-redux'

export interface TableProps {
  subscribes?: Subscribe[]
  loading?: boolean
}

export const Table: React.FC<TableProps> = ({
  subscribes = [],
  loading,
}) => {
  const handlerTariff = useStore($handlerTariff)

  if (loading) {
    return <TableSkeleton />
  }
  return (
    <div className={styles.root}>
      <table className={styles.table}>

        <thead>
          <tr>
            <th>&nbsp;</th>
            {subscribes?.map(({ name }) => (
              <th key={name}>{name}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <Translate id={'tariff.title.price'} />
            </td>
            {subscribes?.map(({ price, currency, period }) => {
              const periodAlias = period === Period.MONTH ? 'tariff.title.period.month' : 'tariff.title.period.year'
              return (
                <td key={price}>
                  {price
                    ? <>
                      {price} {currency} <Translate id={periodAlias} />
                      {period === 30 && <div className={styles.descr}>
                        {/* цена действительна при оплате годовой подписки */}
                      </div>
                      }
                    </>
                    : <Translate id={'tariff.title.price.free'} />
                  }
                </td>
              )
            })}
          </tr>

          {Object.keys(subscribes[0]?.option || {}).map((key, idx) => {
            return (
              <tr key={`tr-${key}`}>
                <td>
                  <Translate id={`tariff.title.${key.toLowerCase()}`} />
                </td>
                {subscribes?.map(({ option, name }) => {
                  const value = option[key]
                  return (
                    <td key={`td-${value}`}>
                      {typeof value === 'string' &&
                        value
                      }
                      {typeof value === 'boolean' &&
                      <>
                        {value &&
                          <CheckCircle fill={name === StatusCard.PRO ? '#10B97B' : '#1373E5'} />
                        }
                      </>
                      }
                    </td>
                  )
                })}
              </tr>
            )
          })}

          {/* <tr> */}
          {/*  <td>Проверка кредитного рейтинга FinScore™</td> */}
          {/*  <td>1 раз</td> */}
          {/*  <td>2 раза / месяц</td> */}
          {/*  <td>4 раза / месяц</td> */}
          {/* </tr> */}

          {/* <tr> */}
          {/*  <td>Проверка кредитной истории</td> */}
          {/*  <td>Платно</td> */}
          {/*  <td>2 раза / месяц</td> */}
          {/*  <td>4 раза / месяц</td> */}
          {/* </tr> */}

          {/* <tr> */}
          {/*  <td>Проверка задолженностей</td> */}
          {/*  <td>1 раз</td> */}
          {/*  <td>2 раза / месяц</td> */}
          {/*  <td>4 раза / месяц</td> */}
          {/* </tr> */}

          {/* <tr> */}
          {/*  <td> */}
          {/*    <div className={styles.iconinfo}> */}
          {/*      <span>Подключение кабинетов Multilogin™</span> */}
          {/*       <Tooltip x={'center'} y={'top'} Target={Information}> */}
          {/*        text tooltip */}
          {/*       </Tooltip> */}
          {/*    </div> */}
          {/*  </td> */}
          {/*  <td>∞</td> */}
          {/*  <td>∞</td> */}
          {/*  <td>∞</td> */}
          {/* </tr> */}

          {/* <tr> */}
          {/*  <td>История моих заявок</td> */}
          {/*  <td>Неделя</td> */}
          {/*  <td>Месяц</td> */}
          {/*  <td>Навсегда</td> */}
          {/* </tr> */}

          {/* <tr> */}
          {/*  <td> */}
          {/*    <div className={styles.iconinfo}> */}
          {/*      <span>Проверка безопасности FinGuard™</span> */}
          {/*      /!* <Tooltip x={'center'} y={'top'} Target={Information}> *!/ */}
          {/*      /!*  text tooltip *!/ */}
          {/*      /!* </Tooltip> *!/ */}
          {/*    </div> */}
          {/*  </td> */}
          {/*  <td>Нет</td> */}
          {/*  <td>Есть</td> */}
          {/*  <td>Есть</td> */}
          {/* </tr> */}

          {/* <tr> */}
          {/*  <td>Скидка на другие пакеты сервиса</td> */}
          {/*  <td>Нет</td> */}
          {/*  <td> */}
          {/*    5% */}
          {/*    <div className={styles.descr}>*скидки не суммируются</div> */}
          {/*  </td> */}
          {/*  <td> */}
          {/*    10% */}
          {/*    <div className={styles.descr}>*скидки не суммируются</div> */}
          {/*  </td> */}
          {/* </tr> */}

          {/* <tr> */}
          {/*  <td>Кэшбэк на кредиты</td> */}
          {/*  <td>Нет</td> */}
          {/*  <td> */}
          {/*    50 - 100 руб. */}
          {/*    <div className={styles.descr}>получайте на свой счет при оформлении займа</div> */}
          {/*  </td> */}
          {/*  <td> */}
          {/*    100 - 150 руб. */}
          {/*    <div className={styles.descr}>получайте на свой счет при оформлении займа</div> */}
          {/*  </td> */}
          {/* </tr> */}

          {/* <tr> */}
          {/*  <td>Проверка кредитного рейтинга</td> */}
          {/*  <td><CheckCircle /></td> */}
          {/*  <td><CheckCircle fill={'#1373E5'} /></td> */}
          {/*  <td><CheckCircle fill={'#10B97B'} /></td> */}
          {/* </tr> */}

          {/* <tr> */}
          {/*  <td>Автозаполнение заявок в МФО</td> */}
          {/*  <td>&nbsp;</td> */}
          {/*  <td><CheckCircle fill={'#1373E5'} /></td> */}
          {/*  <td><CheckCircle fill={'#10B97B'} /></td> */}
          {/* </tr> */}

          {/* <tr> */}
          {/*  <td>Секретные предложения МФО</td> */}
          {/*  <td>&nbsp;</td> */}
          {/*  <td><CheckCircle fill={'#1373E5'} /></td> */}
          {/*  <td><CheckCircle fill={'#10B97B'} /></td> */}
          {/* </tr> */}

          <tr>
            <td>&nbsp;</td>
            {subscribes?.map(({ id, name }) => (
              <td key={id}>
                <Button
                  size="small"
                  className={styles.button}
                  onClick={() => handlerTariff(id)}
                  color={name === StatusCard.PRO ? 'success' : undefined}
                >
                  <Translate id={`tariff.button.${name.toLowerCase()}`} />
                </Button>
              </td>
            ))}
          </tr>
        </tbody>

      </table>
    </div>
  )
}
